/**
 * Better Lyrics (Lyrics for Youtube Music) — synced lyrics overlay for YouTube Music
 *
 * Its main web-accessible-resource entry (blyrics-namespaced CSS, themesong.css, an icon,
 * and marketplace/editor pages) is scoped to music.youtube.com only; a second entry exposes
 * pages/auth.html to the extension's own auth origins. Nothing is served to every origin, so
 * only music.youtube.com can detect it. We probe the vendor-namespaced blyrics CSS there.
 *
 * Manifest verified against version 2.3.2.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'effdbpeggelllpfkjppbokhmmiinhlmg';

export const betterLyrics: ExtensionDefinition = {
  id: ID,
  name: 'Better Lyrics (Lyrics for Youtube Music)',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 80_000,
  requiredOrigin: 'https://music.youtube.com',
  notes:
    'WAR scoped to music.youtube.com (plus an auth page for its own origins), so only ' +
    'music.youtube.com can detect it. A negative from any other origin proves nothing.',
  signals: [
    {
      id: 'war-blyrics-lyrics-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch css/blyrics/lyrics.css — a blyrics-namespaced stylesheet exposed only to ' +
        'music.youtube.com.',
      weight: 1,
      run: () => probeFetch(ID, 'css/blyrics/lyrics.css'),
    },
    {
      id: 'war-themesong-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch css/themesong.css — a distinctively-named stylesheet, a second origin-scoped ' +
        'path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/themesong.css'),
    },
    {
      id: 'war-shaders-png',
      kind: 'web-accessible-resource',
      description:
        'Fetch images/icons/shaders.png — a bundled icon, a third origin-scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'images/icons/shaders.png'),
    },
  ],
};
